module.exports = Promise.all([parcelRequire.load("eMPWC"), parcelRequire.load("bibrp")]).then(() => parcelRequire('Nnf2E'));